import OrderQueueContent from "./OrderQueueContent";

const OrderQueueDisplay = () => {
    return <OrderQueueContent />;
};

export default OrderQueueDisplay;
